import useHiddenLanguageInUrl from '../useHiddenLanguageInUrl';

export const useGetActualPrefixForPath = () => {
  const isHiddenLanguageInUrl = useHiddenLanguageInUrl();

  return (langPrefix) => (isHiddenLanguageInUrl ? '' : langPrefix);
};
